import { CalendarTodayOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { DateRange, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';

import { DateRangePickerStyled } from './SearchDateRangePicker.styled.ts';
import { useSearchDateRange } from './useSearchDateRange.ts';

export interface SearchDateRangePickerProps {
  attribute: string;
}

export const SearchDateRangePicker = ({ attribute }: SearchDateRangePickerProps) => {
  const { min, max, currentDateRange, handleChange, shortcuts } = useSearchDateRange({ attribute });

  return (
    <DateRangePickerStyled
      slots={{ field: MultiInputDateRangeField }}
      minDate={min}
      maxDate={max}
      name={attribute}
      value={currentDateRange}
      onChange={(value, context) => handleChange(value as DateRange<Date>, context)}
      slotProps={{
        textField: {
          label: undefined, // need to overwrite default "Start" and "End" labels
          InputProps: {
            endAdornment: (
              <IconButton sx={(theme) => ({ marginX: `-${theme.spacing(2)}`, color: theme.palette.text.secondary })}>
                <CalendarTodayOutlined />
              </IconButton>
            ),
          },
        },
        shortcuts: {
          items: shortcuts,
        },
        actionBar: { actions: [] },
      }}
      calendars={2}
    />
  );
};
